/**
 * Shared react-select styling so every searchable select on the site — flight
 * airports and interstate bus cities — looks and behaves identically.
 * Extracted from BasicAirportSearchInput; the values are unchanged.
 */
export function buildSelectStyles({
  dark = false,
  pos = "left",
}: {
  dark?: boolean;
  pos?: "left" | "right";
}) {
  return {
    control: (provided: any) => ({
      ...provided,
      backgroundColor: dark ? "transparent" : "#fff",
      border: "none",
      minHeight: "32px",
      borderColor: "none !important",
      outline: "none !important",
      boxShadow: "none", // Disables the box-shadow on focus
      "&:hover": { borderColor: "gray" }, // Optional: style for hover
      "&:focus": { outline: "none" },
    }),
    valueContainer: (base: any) => ({
      ...base,
      height: "32px",
      padding: "0 0px",
      borderColor: "none !important",
      outline: "none !important",
    }),
    input: (base: any) => ({
      ...base,
      margin: "0px",
      padding: "0px",
      height: "32px",
      fontSize: "14px",
      color: dark ? "#fff" : base.color,
      borderColor: "transaparent",
      /* "&:hover": {
      borderColor: state.isFocused ? "#aaa" : base.borderColor,
    }, */
      outline: "none !important",
    }),
    singleValue: (base: any) => ({
      ...base,
      color: dark ? "#fff" : base.color,
    }),
    indicatorsContainer: (base: any) => ({
      ...base,
      height: "32px",
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      color: state.isSelected ? "#ffffff" : "#302D63",
      backgroundColor: state.isSelected ? "#302D63" : "#ffffff",
      padding: "5px 10px",
      margin: "0",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    indicator: () => ({
      display: "none",
    }),
    placeholder: (base: any) => ({
      ...base,
      color: dark ? "rgba(255,255,255,0.4)" : "#17171720",
      fontSize: "1rem",
      lineHeight: "2rem",
      fontWeight: "800",
    }),

    menu: (provided: any) => {
      let x = {
        ...provided,
        backgroundColor: "#ffff",
        borderRadius: "8px",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.15)",
        padding: 0,
        // Must clear the neighbouring fields and whatever follows the hero.
        zIndex: 50,
        width: 350,
      };
      if (pos === "left") {
        x = { ...x, left: 0 };
      } else if (pos === "right") {
        x = { ...x, right: 0 };
      }
      return x;
    },
    container: (base: any) => ({
      ...base,
      width: "100%",
      height: "32px",
    }),
  };
}
